'use client'

import * as Sentry from '@sentry/nextjs'
import { useEffect } from 'react'

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    // Capture error to Sentry
    Sentry.captureException(error)
  }, [error])

  return (
    <html lang="cs">
      <body>
        <div className="flex min-h-screen flex-col items-center justify-center bg-gray-50 p-8">
          <div className="text-center">
            <h1 className="mb-4 text-4xl font-bold text-gray-900">
              Chyba aplikace
            </h1>
            <p className="mb-6 text-gray-600">
              Došlo k závažné chybě. Zkuste obnovit stránku.
            </p>
            <button
              onClick={reset}
              className="rounded-lg bg-blue-600 px-6 py-3 text-white hover:bg-blue-700 transition-colors"
            >
              Obnovit stránku
            </button>
          </div>
        </div>
      </body>
    </html>
  )
}
